import {makeStyles, Theme} from "@material-ui/core";
import {desktop, HD_READY_DESKTOP_BREAKPOINT, mobile} from "../../../../const/sizes";
import { WHITE } from "../../../../const/colors";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        padding: `${desktop.contentSmallerSpacing} 24px ${desktop.contentSmallerSpacing} ${theme.spacing(3)}px`,
        display: 'flex', 
        alignItems: 'center', 
        gap: 20
    },
    appointmentInfoWrapper: {
        display: 'flex',
        flex: 1,
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 24,
    },
    medicPhoto: {
        width: '88px',
        height: '88px',
    },
    appointmentDetailsAndStatus: {
        display: 'flex', 
        flex: 1, 
        flexWrap: 'wrap', 
        alignItems: 'center', 
        flexDirection: 'row', 
        gap: 15
    },
    appointmentDetails: {
        display: 'flex', 
        flexDirection: 'column', 
        flex: 1,
    },
    [theme.breakpoints.down('md')]: {
        appointmentDetailsAndStatus: {
            flexDirection: 'column',
            alignItems: 'flex-start',
        },
        appointmentStatus: {
            flex: 1,
            flexWrap: 'wrap',
        }
    },
    [theme.breakpoints.down('sm')]: {
        container: {
            padding: mobile.contentLargerSpacing,
        }
    },
    [theme.breakpoints.down('xs')]: {
        container: {
            flexDirection: 'column',
            alignItems: 'stretch',
        },
        medicPhoto: {
            width: '70px',
            height: '70px',
        },
        appointmentInfoWrapper: {
            alignItems: 'flex-start',
        },
    }
}));

export default useStyles;